





























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import PublishModal from '@/components/common/ModalPublishProduct.vue';
import { itemsShowOnCard } from '@/constants/product';
import ErrorService from '@/services/erroService';
import UserInterface from '@/types/app/IUser';
import Product from '@/types/app/products';
import VuetifySelectItems from '@/types/app/vuetifySelectItems';
import Endpoint from '@/utils/endpoint';
import formatDate from '@/utils/formatDate';
import formatMoney from '@/utils/formatMoney';
import { getProduct } from '@/utils/getProduct';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { VueEditor } from 'vue2-editor';

const namespace = 'customer';

interface ProductArea {
  description: string;
  area: string;
}

interface ProductFund {
  fundName: string;
  fundSiteName: string;
  fundId: string;
}

@Component({
  data: () => ({
    formType: '',
    required: (v: any) => !!v || 'This field is required',
  }),
  components: { PublishModal, VueEditor },
  methods: {
    formatMoney,
    formatDate,
  },
  watch: {
    '$route.query.type': {
      handler: function (type) {
        this.$data.formType = type;
      },
      deep: true,
      immediate: true,
    },
  },
})
export default class ProductForm extends Vue {
  @Getter('getUser', { namespace: 'auth' }) user!: UserInterface;

  @Getter('getProductSent', { namespace: 'product' }) productSent!: boolean;
  @Action('setProductSent', { namespace: 'product' }) setProductSent!: any;

  @Getter('getProductsState', { namespace: 'product' })
  productsStore!: Product[];

  @Action('setProductsState', { namespace: 'product' })
  setProductsState!: (notification: Product[]) => void;

  @Prop(String) readonly productId!: string;
  @Getter('getProductById', { namespace: 'product' }) getProductById!: (
    id: string
  ) => Product;

  @Watch('productSent')
  getUpdateProduct() {
    this.$router.push({
      name: 'ProductDetail',
      params: {
        productId: this.productId,
      },
      query: { type: 'view' },
    });
  }

  private endpoint = new Endpoint();
  backgroundKey = 0;
  filesKey = 0;
  videoKey = 0;
  id: any;
  loading = false;
  videoToLarge = false;
  areas: VuetifySelectItems[] = [];
  funds: VuetifySelectItems[] = [];
  customToolbar= [
    ["bold", "italic", "underline"],[{ list: "ordered" }, { list: "bullet" }],
    ["image", "code-block"]
  ];
  files = [];
  newFiles = [];
  publish = {
    title: '',
    buttonText: '',
  };
  toogleModal = false;
  status = ['Open', 'Performing'];
  domiciles = ['US', 'NON-US', 'ALL'];
  formType = '';
  videos = [];
  newVideos: any = [];
  newAttachments: any = [];
  background: any = {};
  product: any = {
    attachments: [],
    showCardArray: [],
    showCard:''
  };
  showCard = itemsShowOnCard;
  fromDateMenu = false;
  fromDateMenuInceptionDate = false;
  productSentLoading = false;
  tab = Number(this.$route.params.tab) || 0;
  valid = true;

  tooglePublishModal() {
    this.toogleModal = true;

    this.publish.title = this.product.published
      ? 'Do you want to publish this product ?'
      : 'Do you want to unpublish this product ?';
    this.publish.buttonText = this.product.published ? 'Publish' : 'Unpublish';
  }

  async created() {
    this.loading = true;

    try {
      this.product = this.getProductById(this.productId);
      this.handlerDataProduct();
      const areasForVuetifySelect = await this.getProductAreas();
      const fundsForVuetifySelect = await this.getProductFunds();
      this.areas = areasForVuetifySelect;
      this.funds = fundsForVuetifySelect;
      this.loading = false;
    } catch (error) {
      ErrorService.onError({ status: -1, message: 'Products:Edit:created', error });
      this.loading = false;
    }
  }

  handlerDataProduct() {
    if(this.product){
    const showCardToArray =
        this.product.showCard
            ?.split(',')
            ?.map(
              (item: string) => item.charAt(0).toLowerCase() + item.slice(1)
            ) || [];

        this.product.showCardArray = showCardToArray;
    

    if (this.product?.attachments?.length > 0) this.filterAttachaments();
    }
  }

  async getProductData() {
    const endpoint = new Endpoint();

    this.loading = true;

    try {
      const res = await getProduct(
        endpoint.product,
        this.productId,
        this.$http
      );

      this.setProductsState([...this.productsStore.filter(x => x.id != this.productId), res]);
      this.product = res;
      this.handlerDataProduct();
    } catch (error) {
     ErrorService.onError({ status: -1, message: 'Products:Edit:getProductData', error });
    } finally {
      this.loading = false;
    }
  }

  deleteBackground() {
    this.product.backgroundImage = null;
    this.background = null;
    this.backgroundKey++;
  }

  async deleteVideo(videoTitle: string, videoUrl: string) {
    const url = this.endpoint.productFile;

    await this.$http.delete(url, {
      data: {
        urlFile: videoUrl,
        productId: this.productId,
      },
    });

    this.videos = [];

    this.filesKey++;
  }

  async deleteFile(fileUrl: string) {
    const url = this.endpoint.productFile;

    await this.$http.delete(url, {
      data: {
        urlFile: fileUrl,
        productId: this.productId,
      },
    });

    this.files = this.files.filter(
      (file: { url: string | string[] }) => file.url !== fileUrl
    );

    this.filesKey++;
  }

  filterAttachaments() {
    this.videos = this.product?.attachments.filter(
      (attactment: { url: string | string[] }) =>
        attactment.url.includes('.mp4')
    );

    this.files = this.product?.attachments.filter(
      (attactment: { url: string | string[] }) =>
        !attactment.url.includes('.mp4')
    );
  }

  handleWithSelectedItensByInput(items: any) {
    if (this.likesAllItems(items.showCardArray)) {
      items.showCardArray = [];
    } else {
      items.showCardArray = this.showCard?.slice();
    }
  }

  likesAllItems(selecteds: Array<string>) {
    return selecteds.length === this.showCard?.length;
  }

  likesSomeItems(selecteds: Array<string>) {
    return selecteds.length > 0 && !this.likesAllItems(selecteds);
  }

  icon(value: Array<string>) {
    if (this.likesAllItems(value)) return 'mdi-close-box';
    if (this.likesSomeItems(value)) return 'mdi-minus-box';
    return 'mdi-checkbox-blank-outline';
  }

  getBackgraound() {
    const image: File = this.background;

    this.product.backgroundImage = image;
  }

  getFiles() {
    const files: ReadonlyArray<File> = [
      ...(this.newFiles ? this.newFiles : []),
    ];

    files.forEach((file) => {
      this.newAttachments.push(file);
    });
  }

  getVideos() {
    const video: File = this.newVideos;

    if (video.size > 20000000) {
      this.videoToLarge = true;
      this.newVideos = [];
      this.videoKey++;
      return;
    }

    this.videoToLarge = false;
    this.newAttachments.push(video);
  }

  async getProductAreas(): Promise<VuetifySelectItems[]> {
    const url = this.endpoint.productAreas;
    const response = await this.$http.get(url);
    const productAreas = response.data as ProductArea[];
    const productAreasOrdened = productAreas.sort((a, b) => {
      if (a.description < b.description) {
        return -1;
      }
      if (b.description < a.description) {
        return 1;
      }
      return 0;
    });

    const itemsForVuetifySelect = productAreasOrdened.map((productArea) => ({
      text: productArea.description,
      value: productArea.description,
    }));

    return itemsForVuetifySelect;
  }

  async getProductFunds(): Promise<VuetifySelectItems[]> {
    const url = this.endpoint.productFund;
    const response = await this.$http.get(url);
    const productFunds = response.data as ProductFund[];
    const productFundsOrdened = productFunds.sort((a, b) => {
      if (a.fundSiteName < b.fundSiteName) {
        return -1;
      }
      if (b.fundSiteName < a.fundSiteName) {
        return 1;
      }
      return 0;
    });

    const itemsForVuetifySelect = productFundsOrdened.map((productFund) => ({
      text: productFund.fundSiteName,
      value: productFund.fundId,
    }));

    return itemsForVuetifySelect;
  }


  getFundName(fundId:string){
    return this.funds.find(x => x.value == fundId)?.text;
  }

  async uploadFile(productId: string, element: any) {
    const url = this.endpoint.productFile;

    const formData = new FormData();

    formData.append('file', element);

    await this.$http.post(`${url}/${productId}`, formData, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });
  }

  async uploadBackground(productId: string) {
    const formData = new FormData();

    const url = this.endpoint.productBackground;
    formData.append('file', this.product.backgroundImage);

    await this.$http.post(`${url}/${productId}`, formData, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });
  }

  openExternalLink(link: string): void {
    window.open(link, '_blank');
  }

  private get form(): HTMLFormElement {
    return this.$refs.form as HTMLFormElement;
  }

  closeModal(): void {
    this.$router.replace({
      name: 'ProductDetail',
      params: {
        productId: this.productId,
      },
      query: { type: 'view' },
    });
  }

  async saveProduct() {
    this.toogleModal = false;

    if (!this.form.validate()) {
      return false;
    }

    try {
      const url = this.endpoint.saveProduct;
      this.productSentLoading = true;

      this.product.showCard = String(this.product.showCardArray);

      await this.$http.put(`${url}/${this.productId}`, this.product);

      await this.uploadBackground(this.productId);

      if (this.newAttachments) {
        this.newAttachments.forEach(async (element: any) => {
          await this.uploadFile(this.productId, element);
        });

        this.newFiles = [];
        this.newVideos = [];
        this.background = {};
      }

      this.newAttachments = [];
      this.getProductData();
      this.showProductSentModal();
      
    } catch (error) {
      ErrorService.onError({ status: -1, message: 'EditProduct', error});
      console.error('Error on update a new product');
    }finally{
      this.productSentLoading = false;
    }
  }

  showProductSentModal() {
    this.setProductSent(true);
  }

  clearFields() {
    this.product = {};
  }
}
